import { CssBaseline } from '@mui/material';
import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';

import theme from 'theme';
import Header from 'components/Header/Header';
import Sidebar from 'components/Sidebar/Sidebar';
import MainContent from 'components/MainContent';

const Layout = () => {
  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexGrow: 1,
        minHeight: '100vh',
        overflowX: 'clip',
        backgroundColor: '#F3F5F7',
      }}
    >
      <EmotionThemeProvider theme={theme}>
        <CssBaseline />
        <Header />
        <Sidebar />
        <MainContent />
      </EmotionThemeProvider>
    </Box>
  );
};

export default Layout;
